import { PageDevice } from '../../constants/Device';
import { WebCategory } from '../category/WebCategory';
import { NoticeCategory } from './NoticeCategory';

export const NoticeTarget = {
  TOP: 'newstop',
  PAID_NEWS: 'paidnews',
  RANKING: 'ranking',
  TOPICS_ARTICLES: 'topics',
  SEARCH: 'search',
  LIVE: 'live',
  POLLS: 'polls',
  COMMENT_MODULE: 'comment_module',
  COMMENT_TIMELINE: 'comment_timeline',
  EXPERT: 'expert',
  // 表示管理のデータ上はcomment_profileなので値は表示管理に合わせておく
  PROFILE: 'comment_profile'
} as const;

export type NoticeTarget = (typeof NoticeTarget)[keyof typeof NoticeTarget];

export interface INotice {
  type: 'announce' | 'mediatag';
  createTime: string;
  startTime: string;
  mediaTagId?: string;
  priority: number;
  placements: Array<{
    position?: Position;
    webCategory?: WebCategory;
  }>;
  contents: Array<{
    contentId: number;
    title: string;
    description?: string;
    linkUrl?: string;
    imageUrl?: string;
    isApproachLink: boolean;
    icon?: string;
  }>;
}

export const Position = {
  MAIN_TOP: 'main_top',
  RIGHT_TOP: 'right_top',
  RIGHT_MIDDLE: 'right_middle',
  RIGHT_BOTTOM: 'right_bottom',
  TOP: 'top', // SP_TOP
  MIDDLE: 'middle' // SP_MIDDLE
} as const;

export type Position = (typeof Position)[keyof typeof Position];

export default interface INoticeRepository {
  get(device: PageDevice, noticeTarget: NoticeTarget, noticeCategory?: NoticeCategory): Promise<INotice[] | null>;
}
